import React, { useState } from "react";
import AdminScheduler from "../Admin_scheduler/Admin_scheduler";
import Notifications from "../Notifications/Notifications";
import PaceRender from "../Pace_render/Pace_render";
import Historial from "../Historial/Historial";
import TabContentAdmin from "../ComponentV2/TabContent_admin";
import TabNavItemAdmin from "../ComponentV2/TabNavItem_admin";
import UserRender from "../User_render/User_render";
import BatchRender from "../Batch_operations/Batch_render";
import "./admin_tabs.css";

const Admin_tabs = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  return (
    <div className="tabs-admin">
      {/* Tab nav */}
      <ul className="nav-admin">
        <TabNavItemAdmin
          title="Notificaciones"
          id="tab1"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItemAdmin
          title="Usuarios"
          id="tab2"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItemAdmin
          title="Agendador"
          id="tab3"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItemAdmin
          title="Pace/Mod."
          id="tab4"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItemAdmin
          title="Historial"
          id="tab5"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItemAdmin
          title="Operaciones"
          id="tab6"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </ul>
      <div className="outlet-admin">
        <TabContentAdmin id="tab1" activeTab={activeTab}>
          <Notifications />
        </TabContentAdmin>
        <TabContentAdmin id="tab2" activeTab={activeTab}>
          <UserRender />
        </TabContentAdmin>
        <TabContentAdmin id="tab3" activeTab={activeTab}>
          <AdminScheduler />
        </TabContentAdmin>
        <TabContentAdmin id="tab4" activeTab={activeTab}>
          <PaceRender />
        </TabContentAdmin>
        <TabContentAdmin id="tab5" activeTab={activeTab}>
          <Historial />
        </TabContentAdmin>
        <TabContentAdmin id="tab6" activeTab={activeTab}>
          <BatchRender />
        </TabContentAdmin>
      </div>
    </div>
  );
};
export default Admin_tabs;
